import $ from 'jquery';

/* global x5script */

class Checkout {
  constructor() {
    this.isCheckout = x5script.isCheckout;

    if (!this.isCheckout) {
      return;
    }

    this.dateFields = $('.js-date-field .input-text');

    this.dateFieldsInit();
    this.conditionalFieldsInit();

    // $(window).on('load', () => {
    //   this.macquarieCertFee();
    // });
  }

  dateFieldsInit() {
    if (!this.dateFields.length) {
      return;
    }

    import('flatpickr').then(flatpickr => {
      flatpickr('.js-date-field .input-text', {
        locale: {
          firstDayOfWeek: 1,
        },
        minDate: 'today',
        mode: 'range',
      });
    });
  }

  macquarieCertFee() {
    this.certField = $('#extra_macquarie_cert_field');
    this.certInput = this.certField.find('.input-radio');

    // this.certInput.on('change', () => {
    //   console.log('now');
    //   $('body').trigger('update_checkout');
    // });
  }

  conditionalFieldsInit() {
    this.conditionalFields = $(
      '.woocommerce-additional-fields .form-row.is-conditional',
    );

    if (this.conditionalFields.length) {
      $.each(this.conditionalFields, (i, el) => {
        const field = $(el);
        const fieldClass = field.attr('class');
        const hasShowif = field.hasClass('has-showif');
        let showifValue = null;

        if (hasShowif) {
          const showifElem = field.find('[data-showif]');

          if (showifElem.length) {
            showifValue = showifElem.attr('data-showif');
          }
        }

        if (showifValue) {
          const parentFieldName = fieldClass.match(/is-conditional-([^\s]+)/);
          const parentField = $('.woocommerce-additional-fields').find(
            `.form-row [name="${parentFieldName[1]}"]`,
          );
          const checkboxGroup = $('.woocommerce-additional-fields').find(
            `.form-row.is-checkbox-group#${parentFieldName[1]}_field`,
          );

          if (checkboxGroup.length) {
            let checkboxGroupValues = [];
            const chgFields = checkboxGroup.find('input');

            chgFields
              .on('input', e => {
                const self = $(e.currentTarget);
                const siv = showifValue;

                if (self.is(':checked')) {
                  checkboxGroupValues.push(self.val());
                } else {
                  checkboxGroupValues = checkboxGroupValues.filter(
                    v => v !== self.val(),
                  );
                }

                field.toggle(checkboxGroupValues.includes(siv));
              })
              .trigger('input');
          }

          if (parentField.length) {
            parentField
              .on('input', e => {
                const pf = $(e.currentTarget);
                const siv = showifValue;
                let showField = pf.val() === siv;

                if (pf.attr('type') === 'checkbox') {
                  showField =
                    siv === '1' ? pf.is(':checked') : !pf.is(':checked');
                }

                if (showField) {
                  field.show();
                } else {
                  field.hide();
                }
              })
              .trigger('input');
          }
        }
      });
    }
  }
}

export default new Checkout();



// WEBPACK FOOTER //
// ./src/scripts/modules/checkout.js